import React from 'react';
import { connect } from 'react-redux';
import { footerPuns } from '../../utils/puns';
import { random } from 'lodash';

const Punter_Class = () => {
  const pun = footerPuns[random(0, footerPuns.length - 1)];
  return (
    <footer className="footer">
      <div className="container">
        <span className="footer-copyright">© Count Picula 2018</span>
        <span className="pull-right">{pun}</span>
      </div>
    </footer>
  );
};

// Make the footer aware of this piece of state to re-render the puns between major pages
const mapStateToProps = state => ({
  status: state.users.displayCountStatus
});

const Footer = connect(mapStateToProps)(Punter_Class);

export default Footer;



// WEBPACK FOOTER //
// ./src/comps/Footer/Footer.js